import { render, staticRenderFns } from "./WordSearch.vue?vue&type=template&id=b5b7f1f0&scoped=true"
import script from "./WordSearch.vue?vue&type=script&lang=js"
export * from "./WordSearch.vue?vue&type=script&lang=js"
import style0 from "./WordSearch.vue?vue&type=style&index=0&id=b5b7f1f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b7f1f0",
  null
  
)

export default component.exports